
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { namespace } from "vuex-class";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
// interfaces
import { courseElementTypeItems } from "@/interfaces/Types";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";

const globals = namespace("globals");

@Component({
  components: {
    ExpandableCard,
  },
})
export default class SingleChoiceElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;
  @globals.Getter selectedElement!: CourseElementVm | null;
  @globals.Getter selectedExercise!: ExerciseVM | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;

  mounted() {}

  onConvert() {
    if (!this.selectedElement) return;
    this.selectedElement.type = "MultipleChoice";
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
